import { render } from "./App.vue?vue&type=template&id=dedeb75c&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=dedeb75c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dedeb75c"]])

export default __exports__